module.exports = __webpack_public_path__ + "img/Paciente.23281629.svg";